import React from 'react';

import { numberToLocaleString } from '@atom/utilities/currencyUtility';

import classes from './workOrderReport.module.css';

interface Props {
  title: string;
  emptyHeight?: string;
  actualCost?: number;
  isCompletedOrAbove?: boolean;
  children?: React.ReactNode;
}

const ReportSection = ({
  title,
  emptyHeight,
  actualCost,
  isCompletedOrAbove,
  children,
}: Props) => {
  return (
    <div className={classes.sectionContainer}>
      <div className={classes.sectionTitleContainer}>
        <div>{title}</div>
        {isCompletedOrAbove && <div>{numberToLocaleString(actualCost)}</div>}
      </div>
      {children || <div style={{ height: emptyHeight }} />}
    </div>
  );
};

export default ReportSection;
